<template>
    <div class="us_app">
        <section class="user_section">
            <div class="title jc">
                <h2>약속처방</h2>
            </div>
            <article class="view cmnity">           
                <ul class="category_list">
                    <li @click="fn_category_all" :class="{ on:categoryNum === 'all'}">전체 <strong>({{searchInfo.pageInfo.totPage || 0}})</strong></li>
                    <li 
                        v-for="(item, index) in goodsKindList"
                        :key="index"
                        :class="{ on:categoryNum === index}"
                        @click="click_category(index,item.dtl_code)"
                    >
                        {{ item.dtl_code_nm }}
                        <strong>({{item.count || 0}})</strong>
                    </li>
                </ul>                   
                <div class="search_box">
                    <div>
                        <ul class="sort_list">
                            <li 
                                v-for="(item, index) in sortData" 
                                :key="index"
                                :class="{ on:sortNum === index }"
                                @click="click_short(index,item.code)"
                            >
                                {{ item.name }}
                            </li>
                        </ul>
                    </div>
                    <div class="form_inline">
                        <input type="text" class="form_control" placeholder="검색어를 입력하세요." v-model="searchInfo.promiseGoodsNm">
                        <button class="btn btn_md btn_darkbrown" @click="fn_search">검색</button>
                    </div>
                </div>                                  
                <div class="tab_contents">
                    <div class="lay_left">
                        <ul class="cate_list">
                            <li v-if="promiseList.length == 0">
                                <div>등록된 상품이 없습니다.</div>
                            </li>
                            <li 
                                v-for="(item, index) in promiseList"
                                :key="index"                            >
                                    <div class="img_box" @click="fn_move_detail(item.promise_goods_cd)">
                                        <img :src="'/file/getImgFile/' + item.goods_file_id" alt="">
                                    </div>
                                    <div class="txt_box" @click="fn_move_detail(item.promise_goods_cd)">
                                        <p>{{item.promise_goods_nm}}</p>
                                        <p class="text-sm ellipsis-2">{{item.component_descript}}</p>
                                    </div>

                                    <hr />

                                    <div
                                        v-if="item.prescript_quantity - item.use_quantity <= 30"
                                        class="flex justify-between items-center"
                                    >
                                        <b-badge variant="danger">사전처방 필요</b-badge>
                                        <p class="text-xs">(조제기간 5일)</p>
                                    </div>

                                    <div
                                        v-if="item.prescript_quantity - item.use_quantity > 30"
                                        class="flex justify-between items-center"
                                    >
                                        <p>
                                        <em class="text-xs" style="color: blue">{{
                                            item.prescript_quantity - item.use_quantity
                                        }}</em>
                                        ea
                                        </p>
                                        <b-badge variant="primary">발송가능</b-badge>
                                    </div>

                                    <div class="flex justify-between gap8 mt15 fly_button">
                                        <b-button class="btn btn_md btn_brown btn_outline w100"
                                        @click="fn_prescrip_reg(item.promise_goods_cd)">
                                            사전처방
                                        </b-button>
                                        <b-button class="btn btn_md btn_darkbrown btn_outline w100"
                                        @click="fn_move_detail(item.promise_goods_cd)">
                                            발송요청
                                        </b-button>
                                    </div>
                            </li>
                        </ul>
                        <Pagination :pageInfo="searchInfo.pageInfo" v-show="pagingShow"/>
                    </div>
                </div>
            </article>
            <prePrescriptRegistModal 
                :title="'사전처방등록'"
                :clinic_doctor_id="clinic_doctor_id"
                :promise_goods_cd="promise_goods_cd"
                @callback="fn_prescrip_reg_complet"
            />
        </section>
    </div>
</template>

<script>
    import axios from 'axios'
    import Pagination from "@/components/AdminPagination.vue"
    import commonUtil from "@/mixin/commonUtil";
    import prePrescriptRegistModal from '@/modal/user/prePrescriptRegistModal.vue'

    export default {
        mixins: [commonUtil],
        components: {
            Pagination,
            prePrescriptRegistModal
        },
        data () {
            return {

                //사전처방 등록을 위한 정보
                clinic_doctor_id : '',
                promise_goods_cd : '',

                promiseList: [],
                goodsKindList : [],
                searchInfo : {
                    promiseGoodsNm : '',
                    promiseGoodsKind : '',
                    clinic_doctor_id : '',
                    shortKind : 'N',
                    pageInfo : {
                        page : 1,
                        pageSize : 9,
                        totPage : 0
                    }                
                },
                pagingShow : false,
                sortNum: 3,
                categoryNum: 'all',
                sortData: [
                    {code: 'L', name : '낮은 가격순'}, 
                    {code: 'H', name : '높은 가격순'}, 
                    // {code: 'F', name: '인기 상품순'}, 
                    {code : 'N',name: '상품명 순'}
                    ],
            }
        },
        async created(){

            this.searchInfo.clinic_doctor_id = this.$store.getters['clinicDoctorInfo/getClinicDoctorId'];

            //약속상품 종류 조회
            axios
              .post("/api/user/promise/getPromiseKind")
              .then((res) => {
                  console.log("@@@@ res : %o",res.data.promiseKindList);
                  this.goodsKindList = res.data.promiseKindList;                   

              })
              .catch((err) => console.log(err));

              this.fn_search();
        },
        methods : {
            click_category(index, code){
                this.categoryNum = index;
                this.searchInfo.promiseGoodsKind = code;
                this.fn_search();
            },
            click_short(index,code){
                this.sortNum = index;
                this.searchInfo.shortKind = code;

                this.fn_search();

            },
            fn_search(){

                console.log("@@@@ this.searchInfo : %o",this.searchInfo);

                //약속상품 조회
                axios
                .post("/api/user/promise/getPromiseGoodsList",this.searchInfo)
                .then((res) => {
                    console.log("@@@@ res : %o",res.data.promiseGoodsList);
                    this.promiseList = res.data.promiseGoodsList;
                    
                    this.searchInfo.pageInfo.totPage = res.data.totCnt;
                  
                    if(this.searchInfo.pageInfo.totPage> 0){
                        this.pagingShow = true;                          
                    }    

                })
                .catch((err) => console.log(err));
            },
            fn_move_detail(promiseGoodsCd){
                this.$store.dispatch('promiseGoodsInfo/setPromiseGoodsCd', promiseGoodsCd);             
			    this.$router.push("/PromiseGoodsDetail");	
            },
            fn_category_all(){
                this.categoryNum = 'all';
                this.searchInfo.promiseGoodsKind = '';
                this.fn_search();
            },
            fn_prescrip_reg(goodsCode){
                
                this.clinic_doctor_id = this.$store.getters['clinicDoctorInfo/getClinicDoctorId'];
                this.promise_goods_cd = goodsCode;

                this.$bvModal.show("prePrescriptRegistModal");
            },
            fn_prescrip_reg_complet(){
                this.fn_search();
            },
        }
    }
</script>